import { createPaginatedSlice } from "../../helpers/reduxHelper";

const retailAutomationList = createPaginatedSlice('retailAutomationList');

export const retailAutomationListActions = retailAutomationList.actions
export const retailAutomationListSelector = state => state.retailAutomationList;
export const retailAutomationListReducer = retailAutomationList.reducer;
export default retailAutomationListReducer

export const retailAutomationListSelectors = retailAutomationList.LF.selectors